import React, { useEffect, useRef, useState } from "react";
import {
  API_ENDPOINTS,
  formatStringKey,
  TERMS,
  truncateFormat,
} from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import * as XLSX from "xlsx";
import {
  Form,
  Table,
  Card,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Button,
  InputGroup,
  Dropdown,
  Accordion,
  Toast,
  ProgressBar,
} from "react-bootstrap";
import { pdf } from "@react-pdf/renderer";
import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import {
  IconMailSpark,
  IconFileTypePdf,
  IconHistoryToggle,
  IconFileTypeXls,
  IconFileSearch,
  IconBox,
  IconMessageCircle,
  IconCalendarWeek,
  IconSortAscending,
  IconLayoutGridFilled,
  IconLayoutListFilled,
  IconPaperclip,
  IconDotsVertical,
  IconPencil,
  IconEye,
  IconChevronRight,
} from "@tabler/icons-react";
import useDebounce from "../../hooks/useDebounce";
import moment from "moment";
import { toast } from "react-toastify";
import { MultiSelect } from "primereact/multiselect";
import "primereact/resources/themes/lara-light-blue/theme.css";
import { useSelector } from "react-redux";
import { hasPermission } from "../../utils/_helpers";
import { useNavigate, createSearchParams, useLocation } from "react-router-dom";
import SKU_Version_POPUP from "./SKU_Version_POPUP";
import GetRFQHistoryPOP_UP from "./GetRFQHistoryPOP_UP";
import ExcelDialog from "./ExcelDialog";
import PdfDocument from "./PDF/main";
import KOorCustomerEmailDialog from "./Email/KOorCustomerEmailDialog";
import SuccsessMsgModal from "../../components/SuccessMsgModal";
import EmailQuoteDialog from "./Email/EmailQuoteDialog";
import EmailHistory from "./Email/EmailHistory";
import View_DetailsOpportunity from "./ViewDetail/View_DetailsOpportunity";
import { subYears } from "date-fns/subYears";
import OpportunityListing from "./OpportunityListing";
import useIdleLogout from "../../hooks/useIdleLogout";

const TableListing = ({ externalFilters = null, searchTrigger = 0 }) => {
  const todayDate = new Date();
  const oneYearAgo = subYears(todayDate, 1);
  const [page, setPage] = useState({
    draft: 1,
    pending: 1,
    won: 1,
    lost: 1,
    cancelled: 1,
  });
  const [limit, setLimit] = useState(10);
  const [rfqSku, setRfqSku] = useState("");
  const [startDate, setStartDate] = useState(oneYearAgo);
  const [endDate, setEndDate] = useState(todayDate);
  const [excelData, setExcelData] = useState([]);
  const [draftData, setDraftData] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  const [wonData, setWonData] = useState([]);
  const [lostData, setLostData] = useState([]);
  const [cancelledData, setCancelledData] = useState([]);
  const [activeStatuses, setActiveStatuses] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [highlightedOrders, setHighlightedOrders] = useState([]);
  const [sortOption, setSortOption] = useState("recently_updated");
  const [search, setSearch] = useState("");
  const [salesHeadFilter, setSalesHeadFilter] = useState("");
  const [contractFilter, setContractFilter] = useState("");
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [hasMoreDraft, setHasMoreDraft] = useState(true);
  const [hasMorePending, setHasMorePending] = useState(true);
  const [hasMoreWon, setHasMoreWon] = useState(true);
  const [hasMoreLost, setHasMoreLost] = useState(true);
  const [hasMoreCancelled, setHasMoreCancelled] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isListView, setIsListView] = useState(true);

  const statusOptions = [
    { label: "Draft", value: "DRAFT" },
    { label: "Pending", value: "PENDING" },
    { label: "Won", value: "WON" },
    { label: "Lost", value: "LOST" },
    { label: "Cancelled", value: "CANCELLED" },
  ];

  const sortOptionsMap = {
    recently_updated: {
      sort_by: "updated_at",
      sort_order: "desc",
      label: "Recently Updated",
    },
    created_date_closest: {
      sort_by: "published_date",
      sort_order: "desc",
      label: "Created date closest to now",
    },
    created_date_farthest: {
      sort_by: "published_date",
      sort_order: "asc",
      label: "Created date farthest from now",
    },
    due_date_closest: {
      sort_by: "estimated_date",
      sort_order: "desc",
      label: "Due date closest to now",
    },
    due_date_farthest: {
      sort_by: "estimated_date",
      sort_order: "asc",
      label: "Due date farthest from now",
    },
  };

  const [isSuccsessModalOpen, setIsSuccsessModalOpen] = useState({
    show: false,
    message: "",
    btntext: "Close",
    title: "Success",
  });

  const [isModalOpen, setIsModalOpen] = useState({ show: false });
  const [isHistoryOpen, setIsHistoryOpen] = useState({ show: false });
  const [isExcelOpen, setIsExcelOpen] = useState({ show: false });
  const [isEmaillOpen, setIsEmaillOpen] = useState({
    title: "",
    show: false,
    row: "",
    skuData: "",
    defaultSubject: "",
    Quote_No: "",
    RFQID: "",
    toEmail: "",
    toName: "",
  });
  const [isEmailQuoteOpen, setIsEmailQuoteOpen] = useState({
    show: false,
    Quote_No: "",
    rfq_id: "",
  });
  const [isEmailHistoryOpen, setIsEmailHistoryOpen] = useState({
    show: false,
    rfq_id: "",
  });
  const [isViewOpen, setIsViewOpen] = useState({
    show: false,
    products: [],
    isStatusUpdate: false,
  });

  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const searchInputRef = useRef();
  const tableWrapperRefs = {
    row1: useRef(null),
    row2: useRef(null),
    row3: useRef(null),
    row4: useRef(null),
    row5: useRef(null),
  };
  const dropdownRefs = {
    row1: useRef(null),
    row2: useRef(null),
    row3: useRef(null),
    row4: useRef(null),
    row5: useRef(null),
  };

  const {
    data: draftres,
    loading: loadingDraft,
    postData: fetchOrderDraft,
  } = usePostRequest(API_ENDPOINTS.LISTING_OPPORTUNITIES);
  const {
    data: pendingres,
    loading: loadingPending,
    postData: fetchOrderPending,
  } = usePostRequest(API_ENDPOINTS.LISTING_OPPORTUNITIES);
  const {
    data: wonres,
    loading: loadingWon,
    postData: fetchOrderWon,
  } = usePostRequest(API_ENDPOINTS.LISTING_OPPORTUNITIES);
  const {
    data: lostres,
    loading: loadingLost,
    postData: fetchOrderLost,
  } = usePostRequest(API_ENDPOINTS.LISTING_OPPORTUNITIES);
  const {
    data: cancelledres,
    loading: loadingCancelled,
    postData: fetchOrderCancelled,
  } = usePostRequest(API_ENDPOINTS.LISTING_OPPORTUNITIES);
  const { data: contractData, postData: fetchContract } = usePostRequest(
    API_ENDPOINTS.GET_CONTRACT
  );
  const { data: SalesHead, postData: fetchRfq } = usePostRequest(
    API_ENDPOINTS.GET_RFQ_USERS
  );

  const { debounceSearch } = useDebounce(search);

  // When externalFilters prop is provided (list view driven by parent), use those values
  const hasExternal = externalFilters !== null;
  const resolvedSearch = hasExternal ? (externalFilters.search || "") : search;
  const resolvedSalesHead = hasExternal ? (externalFilters.salesHeadFilter || "") : salesHeadFilter;
  const resolvedContract = hasExternal ? (externalFilters.contractFilter || "") : contractFilter;
  const resolvedStatus = hasExternal ? (externalFilters.selectedStatus || []) : selectedStatus;
  const resolvedSortOption = hasExternal ? (externalFilters.sortOption || "recently_updated") : sortOption;
  const resolvedStartDate = hasExternal ? (externalFilters.startDate || null) : startDate;
  const resolvedEndDate = hasExternal ? (externalFilters.endDate || null) : endDate;
  const resolvedOrderType = hasExternal ? (externalFilters.orderTypeFilter || "") : "";
  const resolvedPaymentType = hasExternal ? (externalFilters.paymentTypeFilter || "") : "";
  const resolvedVendor = hasExternal ? (externalFilters.vendorFilter || "") : "";
  const resolvedProducts = hasExternal ? (externalFilters.selectedProductsFilter || []) : [];
  const resolvedPublishedFrom = hasExternal ? (externalFilters.publishedFrom || null) : null;
  const resolvedPublishedTo = hasExternal ? (externalFilters.publishedTo || null) : null;
  const resolvedDueDateFrom = hasExternal ? (externalFilters.dueDateFrom || null) : null;
  const resolvedDueDateTo = hasExternal ? (externalFilters.dueDateTo || null) : null;

  const isStatusActive = (status) =>
    resolvedStatus.length === 0 || resolvedStatus.includes(status);

  const statusCounts = {
    Draft: isStatusActive("DRAFT") ? draftres?.pagination?.totalRfqs || 0 : 0,
    Pending: isStatusActive("PENDING") ? pendingres?.pagination?.totalRfqs || 0 : 0,
    Won: isStatusActive("WON") ? wonres?.pagination?.totalRfqs || 0 : 0,
    Lost: isStatusActive("LOST") ? lostres?.pagination?.totalRfqs || 0 : 0,
    Cancelled: isStatusActive("CANCELLED") ? cancelledres?.pagination?.totalRfqs || 0 : 0,
  };

  useEffect(() => {
    setExcelData([
      ...draftData,
      ...pendingData,
      ...wonData,
      ...lostData,
      ...cancelledData,
    ]);
  }, [draftData, pendingData, wonData, lostData, cancelledData]);

  const handleGenerateExcel = (selectedFields) => {
    try {
      if (!excelData || excelData?.length === 0) {
        throw new Error("No data available to export");
      }
      if (!selectedFields || selectedFields.length === 0) {
        throw new Error("No fields selected for export");
      }

      const formattedData = excelData?.map((row, index) => {
        const filteredRow = {};
        selectedFields.forEach((field) => {
          switch (field) {
            case "Opportunity Name":
              filteredRow[field] = row?.opportunity_name || "";
              break;
            case "Quote No":
              filteredRow[field] = row.rfq_id || "";
              break;
            case "Contract Vehicle":
              filteredRow[field] = row.ContractType.name || "";
              break;
            case "KO name":
              filteredRow[field] = row.rfqKo.name || "";
              break;
            case "KO email":
              filteredRow[field] = row.rfqKo.email || "";
              break;
            case "KO phone":
              filteredRow[field] = row.rfqKo.phone || "";
              break;
            case "KO address":
              filteredRow[field] = row.rfqKo.address || "";
              break;
            case "Published Date":
              filteredRow[field] = row.published_date
                ? moment(row.published_date).format("MM/DD/YYYY")
                : "";
              break;
            case "Due Date":
              filteredRow[field] = row.due_date
                ? moment(row.due_date).format("MM/DD/YYYY")
                : "";
              break;
            case "Opportunity Description":
              filteredRow[field] = row.brief;
              break;
            case "Organization Name":
              filteredRow[field] = row.organization_name;
              break;

            // case "General Notes":
            //   const GEN_NOTES = row.RfqNotes.find(
            //     (notes) => notes.type === "GEN"
            //   );

            //   filteredRow[field] = GEN_NOTES?.description;
            //   break;

            // case "Billing & Shipping Notes":
            //   const BS_NOTES = row.RfqNotes.find(
            //     (notes) => notes.type === "BS"
            //   );

            //   filteredRow[field] = BS_NOTES?.description;
            //   break;
            // case "Purchase Orders Notes":
            //   const POD_NOTES = row.RfqNotes.find(
            //     (notes) => notes.type === "POD"
            //   );

            //   filteredRow[field] = POD_NOTES?.description;
            //   break;
            // case "Contracting Officer Notes":
            //   const CO_NOTES = row.RfqNotes.find(
            //     (notes) => notes.type === "CO"
            //   );

            //   filteredRow[field] = CO_NOTES?.description;
            //   break;
            // case "Sales Notes":
            //   const SALE_NOTES = row.RfqNotes.find(
            //     (notes) => notes.type === "SALE"
            //   );
            //   filteredRow[field] = SALE_NOTES?.description;
            //   break;

            case "Customer Name":
              filteredRow[field] = row.rfqShipping.name;
              break;
            case "Customer Email":
              filteredRow[field] = row.rfqShipping.email;
              break;
            case "Customer Phone":
              filteredRow[field] = row.rfqShipping.phone;
              break;
            case "Customer Address":
              filteredRow[field] = row.rfqShipping.address;
              break;
            case "Shipping Method":
              filteredRow[field] = row.shipping_method;
              break;
            case "Sales Head Name":
              filteredRow[field] = row.sales_lead_name;
              break;
            case "Sales Head Email":
              filteredRow[field] = row.sales_lead_email;
              break;
            case "Sales Head Ph":
              filteredRow[field] = row.sales_lead_phone;
              break;
            case "Shipping Terms":
              filteredRow[field] = row.shipping_term ? row.shipping_term : "";
              break;
            case "Estimated Delivery":
              filteredRow[field] = row.estimated_delivery;
              break;
            case "Payment Terms":
              const selectedTerm = TERMS.Term.find(
                (term) => term.Id === row.payment_term
              );
              if (selectedTerm) {
                filteredRow[field] = selectedTerm.Name;
              }
              break;
            case "Other Cost": {
              if (row.other_cost_json) {
                try {
                  const otherCosts = Array.isArray(row.other_cost_json)
                    ? row.other_cost_json
                    : JSON.parse(row.other_cost_json);

                  otherCosts.forEach((cost, idx) => {
                    if (cost.Name || cost.Amount) {
                      // Only add if either Name or Amount exists
                      if (cost.Name) {
                        filteredRow[`Other Cost Name${idx + 1}`] = cost.Name;
                      }
                      if (cost.Amount) {
                        filteredRow[`Other Cost ${idx + 1}($)`] = cost.Amount;
                      }
                    }
                  });
                } catch (e) {
                  console.error("Error parsing other_cost_json:", e);
                }
              }
              break;
            }
            case "Shipping Cost($)":
              filteredRow[field] = row.shipping_cost;
              break;
            case "Tax($)":
              filteredRow[field] = row.tax;
              break;
            case "Total Cost Before Margin($)":
              filteredRow[field] = row.total_cost_before_margin;
              break;
            case "Total Cost After Margin($)":
              filteredRow[field] = row.total_cost_after_margin;
              break;
            case "Created Date":
              filteredRow[field] = row.created_at
                ? moment(row.created_at).format("MM/DD/YYYY")
                : "";
              break;
            case "Last Updated Date":
              filteredRow[field] = row.updated_at
                ? moment(row.updated_at).format("MM/DD/YYYY")
                : "";
              break;
            case "Status":
              filteredRow[field] = row.status;
              break;
            default:
              filteredRow[field] = "";
              break;
          }
        });
        return filteredRow;
      });

      if (formattedData.length === 0) {
        throw new Error("No valid data to export");
      }

      // Create a new workbook and worksheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(formattedData);

      XLSX.utils.book_append_sheet(wb, ws, "ASPETTO SALES");
      const today = new Date(); // Get current date
      const excelFileName =
        "ASPETTO SALES-" +
        String(today).split("T")[0] +
        "(" +
        "STATUS:" +
        "" +
        ")" +
        ".xlsx"; // Generate file name
      XLSX.writeFile(wb, excelFileName); // Write Excel file to disk
      console.log("Excel file generated successfully");
    } catch (error) {
      console.error("Error generating Excel file:", error.message);
      alert(error.message); // Display error to the user
    }
  };

  const PD = new Date();
  const today = new Intl.DateTimeFormat("en-US", {
    dateStyle: "medium",
  }).format(PD);

  const HandlePDFClick = async (row) => {
    const OP_arr = String(`opportunity`).split(".");
    for (let i = 0; i < OP_arr?.length; i++) {
      OP_arr[i] = OP_arr[i].charAt(0).toUpperCase() + OP_arr[i].slice(1);
    }
    const updatedInvoiceData = {
      invoice_num: String(row.rfq_id),
      Contract_Vehicle: row.ContractType?.name,
      KO_name: row.rfqKo?.name,
      KO_email: row.rfqKo.email,
      KO_phone: row.rfqKo.phone,
      KO_address: row.rfqKo.address,
      Print_Date: String(today),
      trans_date: String(row.updated_at).split("T")[0],
      estimated_date: row.estimated_date,
      Address:
        "ASPETTO INC, 150 Riverside pkwy. Suite 203. Fredericksburg, VA 22406 USA",
      items: row.RfqProducts,
      Tax: row.tax,
      Shipping_Cost: row.shipping_cost,
      Total_Cost: row.total_cost_after_margin,
      Other_Cost: row.other_cost_json,
      BillTo_Phone: row.rfqBilling.phone,
      BillTo_Name: row.rfqBilling?.name,
      BillTo_Address: row.rfqBilling.address,
      BillTo_Email: row.rfqBilling.email,
      Shipping_Details: {
        Organization_Name: row?.organization_name,
        KO_name: row.rfqKo?.name,
        Sales_Head_Info: {
          Name: row.sales_lead_name,
          Email: row.sales_lead_email,
          Phone: row.sales_lead_phone,
        },
        Customer_Name: row.rfqShipping.name,
        Customer_Email: row.rfqShipping.email,
        Customer_Phone: row.rfqShipping.phone,
        Customer_Address: row.rfqShipping.address,
        Shipping_Method: row.shipping_method,
        Shipping_Method_Detail: row.shipping_method_detail,
        Shipping_Terms: row.shipping_term,
        Estimated_Delivery: row.estimated_delivery,
        Payment_Terms: row.payment_term,
        Payment_Terms_Details: row.payment_term_detail,
      },
    };

    setTimeout(async () => {
      const pdfBlob = await pdf(
        <PdfDocument invoicedata={updatedInvoiceData} />
      ).toBlob();
      const url = URL.createObjectURL(pdfBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${OP_arr.join(" ")} ${
        String(row.invoice_no).split(".")[0]
      }.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 0);
  };

  const handleSearch = () => {
    setActiveStatuses([]);
    const searchValue = searchInputRef.current.value?.trim();
    if ((startDate && !endDate) || (!startDate && endDate)) {
      toast.warning("Please select both the dates.");
      return;
    }
    setPage(() => ({
      draft: 1,
      pending: 1,
      won: 1,
      lost: 1,
      cancelled: 1,
    }));
    setSearch(searchValue);
    setIsInitialLoad(false);
    setIsSearchClicked(true);
  };

  const handlesalesHeadFilter = (e) => {
    setSalesHeadFilter(e.target.value);
  };

  const handleContractFilter = (e) => {
    setContractFilter(e.target.value);
  };

  const handleViewClick = (row) => {
    setIsViewOpen({
      show: true,
      products: row,
      isStatusUpdate: false,
    });
    const currentUrl = window.location.pathname;
    const newUrl = `${currentUrl}?${row.rfq_id}`;
    window.history.pushState(null, "", newUrl);
  };

  useIdleLogout();

  const handleClearFilter = () => {
    setSalesHeadFilter("");
    setContractFilter("");
    setSelectedStatus([]);
    setSearch("");
    setStartDate(oneYearAgo);
    setEndDate(todayDate);
    setSortOption("recently_updated");
    setPage(() => ({
      draft: 1,
      pending: 1,
      won: 1,
      lost: 1,
      cancelled: 1,
    }));
    setIsInitialLoad(true);
    setIsSearchClicked(true);
  };

  const handleSortChange = (sortKey) => {
    setSortOption(sortKey);
    setPage({
      draft: 1,
      pending: 1,
      won: 1,
      lost: 1,
      cancelled: 1,
    });
    setDraftData([]);
    setPendingData([]);
    setWonData([]);
    setLostData([]);
    setCancelledData([]);
    setActiveStatuses([]);
    setIsInitialLoad(false);
    setIsSearchClicked(true);
  };

  const triggerCardHighlight = (orderId) => {
    setHighlightedOrders((prev) => [...prev, orderId]);
    setTimeout(() => {
      setHighlightedOrders((prev) => prev.filter((id) => id !== orderId));
    }, 3000);
  };

  const handleHistoryOpen = (e, order) => {
    e.preventDefault();
    // setOrderSku(order);
    setIsHistoryOpen({ show: true });
  };

  const handleSKUVERSION_OPEN = (e, order) => {
    // e.preventDefault();
    setRfqSku(order);
    setIsModalOpen({ show: true });
  };

  const isPastDate = (dateString) => {
    if (!dateString) return false;
    const estimatedDate = new Date(dateString);
    const today = new Date();
    estimatedDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return estimatedDate < today;
  };

  const getOverdueClass = (dateString) => {
    if (!dateString) return "";
    const estimatedDate = new Date(dateString);
    const today = new Date();
    estimatedDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const daysOverdue = Math.floor(
      (today - estimatedDate) / (1000 * 60 * 60 * 24)
    );
    if (daysOverdue >= 21) return "bg-forred";
    if (daysOverdue >= 10) return "bg-fororange";
    if (daysOverdue >= 2) return "bg-overdate";
    return "";
  };

  // const toggleDropdown = (rowId) => {
  //   setOpenDropdown(openDropdown === rowId ? null : rowId);
  // };

  const toggleDropdown = (id) => {
    const isOpening = openDropdown !== id;
    setOpenDropdown(isOpening ? id : null);

    // Extract the section key (e.g., 'row3') from the rowId (e.g., 'row3-123')
    const sectionKey = id.split("-")[0]; // Gets 'row1', 'row2', etc.

    // Set overflow on the corresponding table wrapper
    if (tableWrapperRefs[sectionKey] && tableWrapperRefs[sectionKey].current) {
      tableWrapperRefs[sectionKey].current.style.overflow = isOpening
        ? "visible"
        : "auto";
    }

    // Reset overflow for other table wrappers
    Object.entries(tableWrapperRefs).forEach(([key, ref]) => {
      if (key !== sectionKey && ref.current) {
        ref.current.style.overflow = "auto";
      }
    });
  };

  const handleDropdownAction = (rowId, action) => {
    const sectionKey = rowId.split("-")[0];
    setOpenDropdown(null); // Close the dropdown
    if (tableWrapperRefs[sectionKey] && tableWrapperRefs[sectionKey].current) {
      tableWrapperRefs[sectionKey].current.style.overflow = "auto"; // Reset overflow
    }
    action(); // Execute the original action
  };

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     Object.entries(dropdownRefs).forEach(([key, ref]) => {
  //       if (ref.current && !ref.current.contains(event.target)) {
  //         if (openDropdown && openDropdown.startsWith(key)) {
  //           setOpenDropdown(null);
  //           if (tableWrapperRefs[key]?.current) {
  //             tableWrapperRefs[key].current.style.overflow = "auto";
  //           }
  //         }
  //       }
  //     });
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, [openDropdown]);

  const onSuccessfulFetchOrderDraft = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMoreDraft(false);
    }
    setDraftData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values()
      );
      return unique;
    });
  };

  const onSuccessfulFetchOrderPending = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMorePending(false);
    }
    setPendingData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values()
      );
      return unique;
    });
  };

  const onSuccessfulFetchOrderWon = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMoreWon(false);
    }
    setWonData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values()
      );
      return unique;
    });
  };

  const onSuccessfulFetchOrderLost = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMoreLost(false);
    }
    setLostData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values()
      );
      return unique;
    });
  };

  const onSuccessfulFetchOrderCancelled = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMoreCancelled(false);
    }
    setCancelledData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values()
      );
      return unique;
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchRfq({ module_type: "RFQ" });
      await fetchContract();
    };
    fetchData();
  }, []);

  // Re-fetch when parent triggers a new search (list view driven by parent filter bar)
  useEffect(() => {
    if (!hasExternal || searchTrigger === 0) return;
    setActiveStatuses([]);
    setDraftData([]);
    setPendingData([]);
    setWonData([]);
    setLostData([]);
    setCancelledData([]);
    setPage({ draft: 1, pending: 1, won: 1, lost: 1, cancelled: 1 });
    setIsInitialLoad(false);
    setIsSearchClicked(true);
  }, [searchTrigger]);

  useEffect(() => {
    const isPagination = page.draft > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (resolvedStatus.length === 0 || resolvedStatus.includes("DRAFT")));
    if (!shouldFetch) return;
    setHasMoreDraft(true);
    fetchOrderDraft(
      {
        page: page.draft,
        limit,
        status: "DRAFT",
        created_date_from: resolvedStartDate ? moment(resolvedStartDate).format("YYYY-MM-DD") : undefined,
        created_date_to: resolvedEndDate ? moment(resolvedEndDate).format("YYYY-MM-DD") : undefined,
        published_date_from: resolvedPublishedFrom ? moment(resolvedPublishedFrom).format("YYYY-MM-DD") : undefined,
        published_date_to: resolvedPublishedTo ? moment(resolvedPublishedTo).format("YYYY-MM-DD") : undefined,
        due_date_from: resolvedDueDateFrom ? moment(resolvedDueDateFrom).format("YYYY-MM-DD") : undefined,
        due_date_to: resolvedDueDateTo ? moment(resolvedDueDateTo).format("YYYY-MM-DD") : undefined,
        sales_lead_email: resolvedSalesHead || undefined,
        search: resolvedSearch?.length > 0 ? resolvedSearch : undefined,
        contract_type_id: resolvedContract?.length > 0 ? resolvedContract : undefined,
        order_type: resolvedOrderType || undefined,
        order_payment_type: resolvedPaymentType || undefined,
        vendor_id: resolvedVendor || undefined,
        sku_ids: resolvedProducts.length > 0 ? resolvedProducts.map((p) => p.sku_id) : undefined,
        ...sortOptionsMap[resolvedSortOption],
      },
      (response) => onSuccessfulFetchOrderDraft(response, page.draft === 1),
      setActiveStatuses((prev) =>
        prev.includes("DRAFT") ? prev : [...prev, "DRAFT"]
      )
    );
    setIsSearchClicked(false);
  }, [page.draft, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.pending > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (resolvedStatus.length === 0 || resolvedStatus.includes("PENDING")));
    if (!shouldFetch) return;
    setHasMorePending(true);
    fetchOrderPending(
      {
        page: page.pending,
        limit,
        status: "PENDING",
        created_date_from: resolvedStartDate ? moment(resolvedStartDate).format("YYYY-MM-DD") : undefined,
        created_date_to: resolvedEndDate ? moment(resolvedEndDate).format("YYYY-MM-DD") : undefined,
        published_date_from: resolvedPublishedFrom ? moment(resolvedPublishedFrom).format("YYYY-MM-DD") : undefined,
        published_date_to: resolvedPublishedTo ? moment(resolvedPublishedTo).format("YYYY-MM-DD") : undefined,
        due_date_from: resolvedDueDateFrom ? moment(resolvedDueDateFrom).format("YYYY-MM-DD") : undefined,
        due_date_to: resolvedDueDateTo ? moment(resolvedDueDateTo).format("YYYY-MM-DD") : undefined,
        sales_lead_email: resolvedSalesHead || undefined,
        search: resolvedSearch?.length > 0 ? resolvedSearch : undefined,
        contract_type_id: resolvedContract?.length > 0 ? resolvedContract : undefined,
        order_type: resolvedOrderType || undefined,
        order_payment_type: resolvedPaymentType || undefined,
        vendor_id: resolvedVendor || undefined,
        sku_ids: resolvedProducts.length > 0 ? resolvedProducts.map((p) => p.sku_id) : undefined,
        ...sortOptionsMap[resolvedSortOption],
      },
      (response) => onSuccessfulFetchOrderPending(response, page.pending === 1),
      setActiveStatuses((prev) =>
        prev.includes("PENDING") ? prev : [...prev, "PENDING"]
      )
    );
    setIsSearchClicked(false);
  }, [page.pending, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.won > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (resolvedStatus.length === 0 || resolvedStatus.includes("WON")));
    if (!shouldFetch) return;
    setHasMoreWon(true);
    fetchOrderWon(
      {
        page: page.won,
        limit,
        status: "WON",
        created_date_from: resolvedStartDate ? moment(resolvedStartDate).format("YYYY-MM-DD") : undefined,
        created_date_to: resolvedEndDate ? moment(resolvedEndDate).format("YYYY-MM-DD") : undefined,
        published_date_from: resolvedPublishedFrom ? moment(resolvedPublishedFrom).format("YYYY-MM-DD") : undefined,
        published_date_to: resolvedPublishedTo ? moment(resolvedPublishedTo).format("YYYY-MM-DD") : undefined,
        due_date_from: resolvedDueDateFrom ? moment(resolvedDueDateFrom).format("YYYY-MM-DD") : undefined,
        due_date_to: resolvedDueDateTo ? moment(resolvedDueDateTo).format("YYYY-MM-DD") : undefined,
        sales_lead_email: resolvedSalesHead || undefined,
        search: resolvedSearch?.length > 0 ? resolvedSearch : undefined,
        contract_type_id: resolvedContract?.length > 0 ? resolvedContract : undefined,
        order_type: resolvedOrderType || undefined,
        order_payment_type: resolvedPaymentType || undefined,
        vendor_id: resolvedVendor || undefined,
        sku_ids: resolvedProducts.length > 0 ? resolvedProducts.map((p) => p.sku_id) : undefined,
        ...sortOptionsMap[resolvedSortOption],
      },
      (response) => onSuccessfulFetchOrderWon(response, page.won === 1),
      setActiveStatuses((prev) =>
        prev.includes("WON") ? prev : [...prev, "WON"]
      )
    );
    setIsSearchClicked(false);
  }, [page.won, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.lost > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (resolvedStatus.length === 0 || resolvedStatus.includes("LOST")));
    if (!shouldFetch) return;
    setHasMoreLost(true);
    fetchOrderLost(
      {
        page: page.lost,
        limit,
        status: "LOST",
        created_date_from: resolvedStartDate ? moment(resolvedStartDate).format("YYYY-MM-DD") : undefined,
        created_date_to: resolvedEndDate ? moment(resolvedEndDate).format("YYYY-MM-DD") : undefined,
        published_date_from: resolvedPublishedFrom ? moment(resolvedPublishedFrom).format("YYYY-MM-DD") : undefined,
        published_date_to: resolvedPublishedTo ? moment(resolvedPublishedTo).format("YYYY-MM-DD") : undefined,
        due_date_from: resolvedDueDateFrom ? moment(resolvedDueDateFrom).format("YYYY-MM-DD") : undefined,
        due_date_to: resolvedDueDateTo ? moment(resolvedDueDateTo).format("YYYY-MM-DD") : undefined,
        sales_lead_email: resolvedSalesHead || undefined,
        search: resolvedSearch?.length > 0 ? resolvedSearch : undefined,
        contract_type_id: resolvedContract?.length > 0 ? resolvedContract : undefined,
        order_type: resolvedOrderType || undefined,
        order_payment_type: resolvedPaymentType || undefined,
        vendor_id: resolvedVendor || undefined,
        sku_ids: resolvedProducts.length > 0 ? resolvedProducts.map((p) => p.sku_id) : undefined,
        ...sortOptionsMap[resolvedSortOption],
      },
      (response) => onSuccessfulFetchOrderLost(response, page.lost === 1),
      setActiveStatuses((prev) =>
        prev.includes("LOST") ? prev : [...prev, "LOST"]
      )
    );
    setIsSearchClicked(false);
  }, [page.lost, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.cancelled > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (resolvedStatus.length === 0 || resolvedStatus.includes("CANCELLED")));
    if (!shouldFetch) return;
    setHasMoreCancelled(true);
    fetchOrderCancelled(
      {
        page: page.cancelled,
        limit,
        status: "CANCELLED",
        created_date_from: resolvedStartDate ? moment(resolvedStartDate).format("YYYY-MM-DD") : undefined,
        created_date_to: resolvedEndDate ? moment(resolvedEndDate).format("YYYY-MM-DD") : undefined,
        published_date_from: resolvedPublishedFrom ? moment(resolvedPublishedFrom).format("YYYY-MM-DD") : undefined,
        published_date_to: resolvedPublishedTo ? moment(resolvedPublishedTo).format("YYYY-MM-DD") : undefined,
        due_date_from: resolvedDueDateFrom ? moment(resolvedDueDateFrom).format("YYYY-MM-DD") : undefined,
        due_date_to: resolvedDueDateTo ? moment(resolvedDueDateTo).format("YYYY-MM-DD") : undefined,
        sales_lead_email: resolvedSalesHead || undefined,
        search: resolvedSearch?.length > 0 ? resolvedSearch : undefined,
        contract_type_id: resolvedContract?.length > 0 ? resolvedContract : undefined,
        order_type: resolvedOrderType || undefined,
        order_payment_type: resolvedPaymentType || undefined,
        vendor_id: resolvedVendor || undefined,
        sku_ids: resolvedProducts.length > 0 ? resolvedProducts.map((p) => p.sku_id) : undefined,
        ...sortOptionsMap[resolvedSortOption],
      },
      (response) =>
        onSuccessfulFetchOrderCancelled(response, page.cancelled === 1),
      setActiveStatuses((prev) =>
        prev.includes("CANCELLED") ? prev : [...prev, "CANCELLED"]
      )
    );
    setIsSearchClicked(false);
  }, [page.cancelled, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  const handleLoadMoreDraft = () => {
    if (hasMoreDraft) {
      setPage((prev) => ({
        ...prev,
        draft: prev.draft + 1,
      }));
    }
  };

  const handleLoadMorePending = () => {
    if (hasMorePending) {
      setPage((prev) => ({
        ...prev,
        pending: prev.pending + 1,
      }));
    }
  };

  const handleLoadMoreWon = () => {
    if (hasMoreWon) {
      setPage((prev) => ({
        ...prev,
        won: prev.won + 1,
      }));
    }
  };

  const handleLoadMoreLost = () => {
    if (hasMoreLost) {
      setPage((prev) => ({
        ...prev,
        lost: prev.lost + 1,
      }));
    }
  };

  const handleLoadMoreCancelled = () => {
    if (hasMoreCancelled) {
      setPage((prev) => ({
        ...prev,
        cancelled: prev.cancelled + 1,
      }));
    }
  };

  return (
    <>
      {isHistoryOpen.show && (
        <GetRFQHistoryPOP_UP
          rfqSku={rfqSku}
          show={isHistoryOpen.show}
          setShow={setIsHistoryOpen}
        />
      )}
      {isModalOpen.show && (
        <SKU_Version_POPUP
          rfqSku={rfqSku}
          show={isModalOpen.show}
          setShow={setIsModalOpen}
        />
      )}
      {isEmailQuoteOpen.show && (
        <EmailQuoteDialog
          username={user.username}
          show={isEmailQuoteOpen.show}
          rfq_id={isEmailQuoteOpen.rfq_id}
          Quote_No={isEmailQuoteOpen.Quote_No}
          setShow={setIsEmailQuoteOpen}
          setIsSuccsessModalOpen={setIsSuccsessModalOpen}
        />
      )}
      {isEmailHistoryOpen.show && (
        <EmailHistory
          username={user.username}
          show={isEmailHistoryOpen.show}
          rfq_id={isEmailHistoryOpen.rfq_id}
          setShow={setIsEmailHistoryOpen}
          setIsSuccsessModalOpen={setIsSuccsessModalOpen}
        />
      )}
      {isViewOpen.show && (
        <View_DetailsOpportunity
          show={isViewOpen.show}
          setShow={setIsViewOpen}
          opportunity={isViewOpen.products}
          isStatusUpdate={isViewOpen.isStatusUpdate}
          onStatusUpdate={() =>
            setIsViewOpen((prev) => ({ ...prev, isStatusUpdate: true }))
          }
          triggerCardHighlight={triggerCardHighlight}
        />
      )}
      {isEmaillOpen.show && (
        <KOorCustomerEmailDialog
          pagetitle={isEmaillOpen.title}
          toEmail={isEmaillOpen.toEmail}
          toName={isEmaillOpen.toName}
          RFQID={isEmaillOpen.RFQID}
          show={isEmaillOpen.show}
          skuData={isEmaillOpen.skuData}
          row={isEmaillOpen.row}
          defaultSubject={isEmaillOpen.defaultSubject}
          Quote_No={isEmaillOpen.Quote_No}
          setShow={setIsEmaillOpen}
          setIsSuccsessModalOpen={setIsSuccsessModalOpen}
        />
      )}
      {isExcelOpen.show && (
        <ExcelDialog
          show={isExcelOpen.show}
          setShow={setIsExcelOpen}
          onDownload={(fields) => {
            handleGenerateExcel(fields);
            setIsExcelOpen({ show: false });
          }}
        />
      )}
      <SuccsessMsgModal
        show={isSuccsessModalOpen.show}
        onHide={() =>
          setIsSuccsessModalOpen({ ...isSuccsessModalOpen, show: false })
        }
        title={isSuccsessModalOpen?.title}
        btntext={isSuccsessModalOpen?.btntext}
        message={isSuccsessModalOpen?.message}
      />
      {isListView && !hasExternal ? (
        <div className="page-header d-print-none">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Opportunities</h2>
            </div>
          </div>
        </div>
      ) : null}
      {isListView && !hasExternal ? (
        <Card className="mb-3">
          <Card.Body>
            <Form
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSearch();
                }
              }}
            >
              <Row>
                <Col lg={2} md={4} className="mb-2">
                  <Form.Label className="form-label">Search</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <IconFileSearch />
                    </InputGroup.Text>
                    <Form.Control
                      ref={searchInputRef}
                      type="text"
                      placeholder="Search..."
                      required
                      name="name"
                      autoComplete="off"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </InputGroup>
                </Col>
                <Col lg={2} md={4} className="mb-2">
                  <Form.Label className="form-label">
                    Sales Lead Email
                  </Form.Label>
                  <Form.Select
                    className="form-control"
                    value={salesHeadFilter}
                    onChange={handlesalesHeadFilter}
                  >
                    <option value="">All</option>
                    {SalesHead?.data?.map((sales) => (
                      <option key={sales?.id} value={sales?.email}>
                        {sales?.email}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col lg={2} md={4} className="mb-2">
                  <Form.Label className="form-label">Select Status</Form.Label>
                  <MultiSelect
                    value={selectedStatus}
                    options={statusOptions}
                    onChange={(e) => setSelectedStatus(e.value)}
                    optionLabel="label"
                    placeholder="All"
                    display="chip"
                    className="w-100"
                    panelHeaderTemplate={() => null}
                  />
                </Col>
                <Col lg={2} md={4} className="mb-2">
                  <Form.Label className="form-label">
                    Contract Vehicle
                  </Form.Label>
                  <Form.Select
                    className="form-control"
                    value={contractFilter}
                    onChange={handleContractFilter}
                  >
                    <option value="">All</option>
                    {contractData?.data?.map((vehicle, index) => (
                      <option key={index} value={vehicle.id}>
                        {vehicle.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col lg={4} md={8} className="mb-2">
                  <div className="d-flex gap-2">
                    <div className="w-100">
                      <Form.Label className="form-label">
                        Created Date From
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <IconCalendarWeek />
                        </InputGroup.Text>
                        <DatePicker
                          className="form-control"
                          selected={startDate}
                          placeholderText="Select Date"
                          onChange={(date) => setStartDate(date)}
                          selectsStart
                          startDate={startDate}
                          endDate={endDate}
                          showMonthDropdown
                          showYearDropdown
                        />
                      </InputGroup>
                    </div>
                    <div className="w-100">
                      <Form.Label className="form-label">
                        Created Date To
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <IconCalendarWeek />
                        </InputGroup.Text>
                        <DatePicker
                          className="form-control"
                          selected={endDate}
                          placeholderText="Select Date"
                          onChange={(date) => setEndDate(date)}
                          selectsEnd
                          startDate={startDate}
                          endDate={endDate}
                          minDate={startDate}
                          showMonthDropdown
                          showYearDropdown
                        />
                      </InputGroup>
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={12} className="mb-2 mt-2">
                  <div className="d-flex gap-2">
                    <Button
                      style={{ minWidth: "auto" }}
                      variant="warning"
                      onClick={handleSearch}
                    >
                      Apply Filters
                    </Button>
                    <Button
                      style={{ minWidth: "auto" }}
                      variant="outline-secondary"
                      onClick={handleClearFilter}
                    >
                      Clear Filters
                    </Button>
                    <Button
                      style={{ minWidth: "auto" }}
                      onClick={() => setIsExcelOpen({ show: true })}
                      variant="outline-success"
                    >
                      <IconFileTypeXls /> Download
                    </Button>
                  </div>
                </Col>
                <Form.Text>
                  Search by opportunity ID, contracting officer information,
                  description or any other relevant keyword.
                </Form.Text>
              </Row>
            </Form>
          </Card.Body>
        </Card>
      ) : null}
      {isListView && !hasExternal ? (
        <div className="d-flex align-items-center justify-content-end pt-2 pb-3 gap-3">
          <Dropdown onSelect={handleSortChange}>
            <Dropdown.Toggle variant="light" className="shortDropdown">
              <IconSortAscending />
              {sortOption ? sortOptionsMap[sortOption]?.label : "Sort By"}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item eventKey="recently_updated">
                Recently updated
              </Dropdown.Item>
              <Dropdown.Item eventKey="created_date_closest">
                Created date closest to now
              </Dropdown.Item>
              <Dropdown.Item eventKey="created_date_farthest">
                Created date farthest from now
              </Dropdown.Item>
              <Dropdown.Item eventKey="due_date_closest">
                Due date closest to now
              </Dropdown.Item>
              <Dropdown.Item eventKey="due_date_farthest">
                Due date farthest from now
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <div className="view-toggle d-flex align-items-center justify-content-end gap-1">
            <IconLayoutGridFilled
              onClick={() => setIsListView(false)}
              style={{
                cursor: "pointer",
                color: !isListView ? "#FE6338" : "#515151",
              }}
            />
            <IconLayoutListFilled
              onClick={() => setIsListView(true)}
              style={{
                cursor: "pointer",
                color: isListView ? "#FE6338" : "#515151",
              }}
            />
          </div>
        </div>
      ) : null}
      {isListView ? (
        <div className="order_list_view">
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0" className="border-0">
              <Accordion.Header>
                <span className="order_status_box draft_status">
                  Draft{" "}
                  <b style={{ color: "#818183ff" }}>{statusCounts.Draft}</b>
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <div
                  className="table-responsive mail_wrapper border-0 p-0"
                  ref={tableWrapperRefs.row1}
                  style={{ overflowX: "auto" }}
                >
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Opportunity ID</th>
                        <th>Sales Lead</th>
                        <th>Contract Vehicle</th>
                        <th>Created Date</th>
                        <th>Type</th>
                        <th>Total Cost</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {draftData.length > 0 ? (
                        draftData.map((row, index) => {
                          const overdueClass = getOverdueClass(row?.due_date);

                          const rowId = `row1-${row.rfq_id}`;
                          return (
                            <tr
                              key={index}
                              className={`align-middle ${overdueClass} ${
                                highlightedOrders.includes(row.rfq_id)
                                  ? `highlight-draft`
                                  : ""
                              }`}
                            >
                              <td>{row.rfq_id}</td>
                              <td>{row?.sales_lead_name || "N/A"}</td>
                              <td>{row?.ContractType?.name || "N/A"}</td>
                              <td>
                                {moment(row?.published_date).format(
                                  "MM/DD/YYYY"
                                )}
                              </td>
                              <td>
                                {row?.opportunity_type === "RFQ"
                                  ? "OPPORTUNITY"
                                  : row?.opportunity_type}
                              </td>
                              <td className="text-primary">
                                ${row?.total_cost_after_margin}{" "}
                                {(() => {
                                  const after = Number(
                                    row?.total_cost_after_margin
                                  );
                                  const before = Number(
                                    row?.total_cost_before_margin
                                  );
                                  const profit = after - before;
                                  const percentage =
                                    after !== 0 ? (profit / after) * 100 : 0;
                                  return `(${truncateFormat(percentage, 2)}%)`;
                                })()}
                              </td>
                              <td
                                style={{ position: "relative" }}
                                ref={dropdownRefs.row1}
                              >
                                <button
                                  onClick={() => toggleDropdown(rowId)}
                                  style={{
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <IconDotsVertical size={20} />
                                </button>
                                {openDropdown === rowId && (
                                  <ul className="order-dropdown-menu p-0">
                                    <li
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () => {
                                          navigate(`/edit-rfq/${row?.rfq_id}`);
                                        })
                                      }
                                      // onClick={(e) => {
                                      //   e.stopPropagation();
                                      //   navigate(`/edit-rfq/${row?.rfq_id}`);
                                      // }}
                                    >
                                      <span>
                                        <IconPencil stroke={1} /> Edit RFQ
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      // onClick={() => handleViewClick(row)}
                                      onClick={() =>
                                        handleDropdownAction(rowId, () =>
                                          handleViewClick(row)
                                        )
                                      }
                                    >
                                      <span>
                                        <IconEye stroke={1} /> View RFQ
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () =>
                                          handleSKUVERSION_OPEN(
                                            null,
                                            row.rfq_id
                                          )
                                        )
                                      }
                                      // onClick={(e) =>
                                      //   handleORDERRVERSION_OPEN(e, row.rfq_id)
                                      // }
                                    >
                                      <span>
                                        <IconHistoryToggle stroke={1} /> Changes
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () => {
                                          HandlePDFClick(row);
                                        })
                                      }
                                      // onClick={(e) => {
                                      //   e.preventDefault();
                                      //   e.stopPropagation();
                                      //   HandlePDFClick(row);
                                      // }}
                                    >
                                      <span>
                                        <IconFileTypePdf stroke={1} /> PDF
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () => {
                                          setIsEmailHistoryOpen({
                                            show: true,
                                            rfq_id: row.rfq_id,
                                          });
                                        })
                                      }
                                      // onClick={(e) => {
                                      //   e.stopPropagation();
                                      //   setIsEmailHistoryOpen({
                                      //     show: true,
                                      //     rfq_id: row.rfq_id,
                                      //   });
                                      // }}
                                    >
                                      <span>
                                        <IconMailSpark stroke={1} /> Email
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li className="border-top">
                                      <div className="rfq_lis_short justify-content-center p-2">
                                        <span>
                                          <IconBox stroke={1} />{" "}
                                          {row.RfqProducts.length}
                                        </span>
                                        <span>
                                          <IconPaperclip stroke={1} />{" "}
                                          {row.Attachments.length}
                                        </span>
                                        <span>
                                          <IconMessageCircle stroke={1} />{" "}
                                          {row.section.reduce(
                                            (acc, section) =>
                                              acc + section.notes.length,
                                            0
                                          )}
                                        </span>
                                      </div>
                                    </li>
                                  </ul>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No data found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {draftres?.data?.length >= 10 && hasMoreDraft && (
                    <div className="text-center mt-3">
                      <Button
                        variant="outline-primary"
                        onClick={handleLoadMoreDraft}
                        disabled={loadingDraft}
                      >
                        {loadingDraft ? "Loading..." : "Load More"}
                      </Button>
                    </div>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1" className="border-0">
              <Accordion.Header>
                <span className="order_status_box pending_status">
                  Pending{" "}
                  <b style={{ color: "#F59F00" }}>{statusCounts.Pending}</b>
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <div
                  className="table-responsive mail_wrapper border-0 p-0"
                  ref={tableWrapperRefs.row2}
                  style={{ overflowX: "auto" }}
                >
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Opportunity ID</th>
                        <th>Sales Lead</th>
                        <th>Contract Vehicle</th>
                        <th>Created Date</th>
                        <th>Type</th>
                        <th>Total Cost</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pendingData.length > 0 ? (
                        pendingData.map((row, index) => {
                          const overdueClass = getOverdueClass(row?.due_date);
                          const rowId = `row2-${row.rfq_id}`;
                          return (
                            <tr
                              key={index}
                              className={`align-middle ${overdueClass} ${
                                highlightedOrders.includes(row.rfq_id)
                                  ? `highlight-pending`
                                  : ""
                              }`}
                            >
                              <td>{row.rfq_id}</td>
                              <td>{row?.sales_lead_name || "N/A"}</td>
                              <td>{row?.ContractType?.name || "N/A"}</td>
                              <td>
                                {moment(row?.published_date).format(
                                  "MM/DD/YYYY"
                                )}
                              </td>
                              <td>
                                {row?.opportunity_type === "RFQ"
                                  ? "OPPORTUNITY"
                                  : row?.opportunity_type}
                              </td>
                              <td className="text-primary">
                                ${row?.total_cost_after_margin}{" "}
                                {(() => {
                                  const after = Number(
                                    row?.total_cost_after_margin
                                  );
                                  const before = Number(
                                    row?.total_cost_before_margin
                                  );
                                  const profit = after - before;
                                  const percentage =
                                    after !== 0 ? (profit / after) * 100 : 0;
                                  return `(${truncateFormat(percentage, 2)}%)`;
                                })()}
                              </td>
                              <td
                                style={{ position: "relative" }}
                                ref={dropdownRefs.row2}
                              >
                                <button
                                  onClick={() => toggleDropdown(rowId)}
                                  style={{
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <IconDotsVertical size={20} />
                                </button>
                                {openDropdown === rowId && (
                                  <ul className="order-dropdown-menu p-0">
                                    <li
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () => {
                                          navigate(`/edit-rfq/${row?.rfq_id}`);
                                        })
                                      }
                                    >
                                      <span>
                                        <IconPencil stroke={1} /> Edit RFQ
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () =>
                                          handleViewClick(row)
                                        )
                                      }
                                    >
                                      <span>
                                        <IconEye stroke={1} /> View RFQ
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () =>
                                          handleSKUVERSION_OPEN(
                                            null,
                                            row.rfq_id
                                          )
                                        )
                                      }
                                    >
                                      <span>
                                        <IconHistoryToggle stroke={1} /> Changes
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () => {
                                          HandlePDFClick(row);
                                        })
                                      }
                                    >
                                      <span>
                                        <IconFileTypePdf stroke={1} /> PDF
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () => {
                                          setIsEmailHistoryOpen({
                                            show: true,
                                            rfq_id: row.rfq_id,
                                          });
                                        })
                                      }
                                    >
                                      <span>
                                        <IconMailSpark stroke={1} /> Email
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li className="border-top">
                                      <div className="rfq_lis_short justify-content-center p-2">
                                        <span>
                                          <IconBox stroke={1} />{" "}
                                          {row.RfqProducts.length}
                                        </span>
                                        <span>
                                          <IconPaperclip stroke={1} />{" "}
                                          {row.Attachments.length}
                                        </span>
                                        <span>
                                          <IconMessageCircle stroke={1} />{" "}
                                          {row.section.reduce(
                                            (acc, section) =>
                                              acc + section.notes.length,
                                            0
                                          )}
                                        </span>
                                      </div>
                                    </li>
                                  </ul>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No data found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {pendingres?.data?.length >= 10 && hasMorePending && (
                    <div className="text-center mt-3">
                      <Button
                        variant="outline-primary"
                        onClick={handleLoadMorePending}
                        disabled={loadingPending}
                      >
                        {loadingPending ? "Loading..." : "Load More"}
                      </Button>
                    </div>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2" className="border-0">
              <Accordion.Header>
                <span className="order_status_box won_status">
                  Won <b style={{ color: "#198754" }}>{statusCounts.Won}</b>
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <div
                  className="table-responsive mail_wrapper border-0 p-0"
                  ref={tableWrapperRefs.row3}
                  style={{ overflowX: "auto" }}
                >
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Opportunity ID</th>
                        <th>Sales Lead</th>
                        <th>Contract Vehicle</th>
                        <th>Created Date</th>
                        <th>Type</th>
                        <th>Total Cost</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {wonData.length > 0 ? (
                        wonData.map((row, index) => {
                          const overdueClass = getOverdueClass(row?.due_date);
                          const rowId = `row3-${row.rfq_id}`;
                          return (
                            <tr
                              key={index}
                              className={`align-middle ${overdueClass} ${
                                highlightedOrders.includes(row.rfq_id)
                                  ? `highlight-won`
                                  : ""
                              }`}
                            >
                              <td>{row.rfq_id}</td>
                              <td>{row?.sales_lead_name || "N/A"}</td>
                              <td>{row?.ContractType?.name || "N/A"}</td>
                              <td>
                                {moment(row?.published_date).format(
                                  "MM/DD/YYYY"
                                )}
                              </td>

                              <td>
                                {row?.opportunity_type === "RFQ"
                                  ? "OPPORTUNITY"
                                  : row?.opportunity_type}
                              </td>
                              <td className="text-primary">
                                ${row?.total_cost_after_margin}{" "}
                                {(() => {
                                  const after = Number(
                                    row?.total_cost_after_margin
                                  );
                                  const before = Number(
                                    row?.total_cost_before_margin
                                  );
                                  const profit = after - before;
                                  const percentage =
                                    after !== 0 ? (profit / after) * 100 : 0;
                                  return `(${truncateFormat(percentage, 2)}%)`;
                                })()}
                              </td>
                              <td
                                style={{ position: "relative" }}
                                ref={dropdownRefs.row3}
                              >
                                <button
                                  onClick={() => toggleDropdown(rowId)}
                                  style={{
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <IconDotsVertical size={20} />
                                </button>
                                {openDropdown === rowId && (
                                  <ul className="order-dropdown-menu p-0">
                                    <li
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () => {
                                          navigate(`/edit-rfq/${row?.rfq_id}`);
                                        })
                                      }
                                    >
                                      <span>
                                        <IconPencil stroke={1} /> Edit RFQ
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () =>
                                          handleViewClick(row)
                                        )
                                      }
                                    >
                                      <span>
                                        <IconEye stroke={1} /> View RFQ
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () =>
                                          handleSKUVERSION_OPEN(
                                            null,
                                            row.rfq_id
                                          )
                                        )
                                      }
                                    >
                                      <span>
                                        <IconHistoryToggle stroke={1} /> Changes
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () => {
                                          HandlePDFClick(row);
                                        })
                                      }
                                    >
                                      <span>
                                        <IconFileTypePdf stroke={1} /> PDF
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () => {
                                          setIsEmailHistoryOpen({
                                            show: true,
                                            rfq_id: row.rfq_id,
                                          });
                                        })
                                      }
                                    >
                                      <span>
                                        <IconMailSpark stroke={1} /> Email
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li className="border-top">
                                      <div className="rfq_lis_short justify-content-center p-2">
                                        <span>
                                          <IconBox stroke={1} />{" "}
                                          {row.RfqProducts.length}
                                        </span>
                                        <span>
                                          <IconPaperclip stroke={1} />{" "}
                                          {row.Attachments.length}
                                        </span>
                                        <span>
                                          <IconMessageCircle stroke={1} />{" "}
                                          {row.section.reduce(
                                            (acc, section) =>
                                              acc + section.notes.length,
                                            0
                                          )}
                                        </span>
                                      </div>
                                    </li>
                                  </ul>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No data found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {wonres?.data?.length >= 10 && hasMoreWon && (
                    <div className="text-center mt-3">
                      <Button
                        variant="outline-primary"
                        onClick={handleLoadMoreWon}
                        disabled={loadingWon}
                      >
                        {loadingWon ? "Loading..." : "Load More"}
                      </Button>
                    </div>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3" className="border-0">
              <Accordion.Header>
                <span className="order_status_box closed_status">
                  Lost <b style={{ color: "#D63939" }}>{statusCounts.Lost}</b>
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <div
                  className="table-responsive mail_wrapper border-0 p-0"
                  ref={tableWrapperRefs.row4}
                  style={{ overflowX: "auto" }}
                >
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Opportunity ID</th>
                        <th>Sales Lead</th>
                        <th>Contract Vehicle</th>
                        <th>Created Date</th>
                        <th>Type</th>
                        <th>Total Cost</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lostData.length > 0 ? (
                        lostData.map((row, index) => {
                          const overdueClass = getOverdueClass(row?.due_date);
                          const rowId = `row4-${row.rfq_id}`;
                          return (
                            <tr
                              key={index}
                              className={`align-middle ${overdueClass} ${
                                highlightedOrders.includes(row.rfq_id)
                                  ? `highlight-lost`
                                  : ""
                              }`}
                            >
                              <td>{row.rfq_id}</td>
                              <td>{row?.sales_lead_name || "N/A"}</td>
                              <td>{row?.ContractType?.name || "N/A"}</td>
                              <td>
                                {moment(row?.published_date).format(
                                  "MM/DD/YYYY"
                                )}
                              </td>
                              <td>
                                {row?.opportunity_type === "RFQ"
                                  ? "OPPORTUNITY"
                                  : row?.opportunity_type}
                              </td>
                              <td className="text-primary">
                                ${row?.total_cost_after_margin}{" "}
                                {(() => {
                                  const after = Number(
                                    row?.total_cost_after_margin
                                  );
                                  const before = Number(
                                    row?.total_cost_before_margin
                                  );
                                  const profit = after - before;
                                  const percentage =
                                    after !== 0 ? (profit / after) * 100 : 0;
                                  return `(${truncateFormat(percentage, 2)}%)`;
                                })()}
                              </td>
                              <td
                                style={{ position: "relative" }}
                                ref={dropdownRefs.row4}
                              >
                                <button
                                  onClick={() => toggleDropdown(rowId)}
                                  style={{
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <IconDotsVertical size={20} />
                                </button>
                                {openDropdown === rowId && (
                                  <ul className="order-dropdown-menu p-0">
                                    <li
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () => {
                                          navigate(`/edit-rfq/${row?.rfq_id}`);
                                        })
                                      }
                                    >
                                      <span>
                                        <IconPencil stroke={1} /> Edit RFQ
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () =>
                                          handleViewClick(row)
                                        )
                                      }
                                    >
                                      <span>
                                        <IconEye stroke={1} /> View RFQ
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () =>
                                          handleSKUVERSION_OPEN(
                                            null,
                                            row.rfq_id
                                          )
                                        )
                                      }
                                    >
                                      <span>
                                        <IconHistoryToggle stroke={1} /> Changes
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () => {
                                          HandlePDFClick(row);
                                        })
                                      }
                                    >
                                      <span>
                                        <IconFileTypePdf stroke={1} /> PDF
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () => {
                                          setIsEmailHistoryOpen({
                                            show: true,
                                            rfq_id: row.rfq_id,
                                          });
                                        })
                                      }
                                    >
                                      <span>
                                        <IconMailSpark stroke={1} /> Email
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li className="border-top">
                                      <div className="rfq_lis_short justify-content-center p-2">
                                        <span>
                                          <IconBox stroke={1} />{" "}
                                          {row.RfqProducts.length}
                                        </span>
                                        <span>
                                          <IconPaperclip stroke={1} />{" "}
                                          {row.Attachments.length}
                                        </span>
                                        <span>
                                          <IconMessageCircle stroke={1} />{" "}
                                          {row.section.reduce(
                                            (acc, section) =>
                                              acc + section.notes.length,
                                            0
                                          )}
                                        </span>
                                      </div>
                                    </li>
                                  </ul>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No data found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {lostres?.data?.length >= 10 && hasMoreLost && (
                    <div className="text-center mt-3">
                      <Button
                        variant="outline-primary"
                        onClick={handleLoadMoreLost}
                        disabled={loadingLost}
                      >
                        {loadingLost ? "Loading..." : "Load More"}
                      </Button>
                    </div>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4" className="border-0">
              <Accordion.Header>
                <span className="order_status_box closed_status">
                  Cancelled{" "}
                  <b style={{ color: "#D63939" }}>{statusCounts.Cancelled}</b>
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <div
                  className="table-responsive mail_wrapper border-0 p-0"
                  ref={tableWrapperRefs.row5}
                  style={{ overflowX: "auto" }}
                >
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Opportunity ID</th>
                        <th>Sales Lead</th>
                        <th>Contract Vehicle</th>
                        <th>Created Date</th>
                        <th>Type</th>
                        <th>Total Cost</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cancelledData.length > 0 ? (
                        cancelledData.map((row, index) => {
                          const overdueClass = getOverdueClass(row?.due_date);
                          const rowId = `row5-${row.rfq_id}`;
                          return (
                            <tr
                              key={index}
                              className={`align-middle ${overdueClass} ${
                                highlightedOrders.includes(row.rfq_id)
                                  ? `highlight-cancelled`
                                  : ""
                              }`}
                            >
                              <td>{row.rfq_id}</td>
                              <td>{row?.sales_lead_name || "N/A"}</td>
                              <td>{row?.ContractType?.name || "N/A"}</td>
                              <td>
                                {moment(row?.published_date).format(
                                  "MM/DD/YYYY"
                                )}
                              </td>
                              <td>
                                {row?.opportunity_type === "RFQ"
                                  ? "OPPORTUNITY"
                                  : row?.opportunity_type}
                              </td>
                              <td className="text-primary">
                                ${row?.total_cost_after_margin}{" "}
                                {(() => {
                                  const after = Number(
                                    row?.total_cost_after_margin
                                  );
                                  const before = Number(
                                    row?.total_cost_before_margin
                                  );
                                  const profit = after - before;
                                  const percentage =
                                    after !== 0 ? (profit / after) * 100 : 0;
                                  return `(${truncateFormat(percentage, 2)}%)`;
                                })()}
                              </td>
                              <td
                                style={{ position: "relative" }}
                                ref={dropdownRefs.row5}
                              >
                                <button
                                  onClick={() => toggleDropdown(rowId)}
                                  style={{
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <IconDotsVertical size={20} />
                                </button>
                                {openDropdown === rowId && (
                                  <ul className="order-dropdown-menu p-0">
                                    <li
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () => {
                                          navigate(`/edit-rfq/${row?.rfq_id}`);
                                        })
                                      }
                                    >
                                      <span>
                                        <IconPencil stroke={1} /> Edit RFQ
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () =>
                                          handleViewClick(row)
                                        )
                                      }
                                    >
                                      <span>
                                        <IconEye stroke={1} /> View RFQ
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () =>
                                          handleSKUVERSION_OPEN(
                                            null,
                                            row.rfq_id
                                          )
                                        )
                                      }
                                    >
                                      <span>
                                        <IconHistoryToggle stroke={1} /> Changes
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () => {
                                          HandlePDFClick(row);
                                        })
                                      }
                                    >
                                      <span>
                                        <IconFileTypePdf stroke={1} /> PDF
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li
                                      className="dropdown-item border-top"
                                      onClick={() =>
                                        handleDropdownAction(rowId, () => {
                                          setIsEmailHistoryOpen({
                                            show: true,
                                            rfq_id: row.rfq_id,
                                          });
                                        })
                                      }
                                    >
                                      <span>
                                        <IconMailSpark stroke={1} /> Email
                                      </span>
                                      <IconChevronRight stroke={1} />
                                    </li>
                                    <li className="border-top">
                                      <div className="rfq_lis_short justify-content-center p-2">
                                        <span>
                                          <IconBox stroke={1} />{" "}
                                          {row.RfqProducts.length}
                                        </span>
                                        <span>
                                          <IconPaperclip stroke={1} />{" "}
                                          {row.Attachments.length}
                                        </span>
                                        <span>
                                          <IconMessageCircle stroke={1} />{" "}
                                          {row.section.reduce(
                                            (acc, section) =>
                                              acc + section.notes.length,
                                            0
                                          )}
                                        </span>
                                      </div>
                                    </li>
                                  </ul>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No data found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {cancelledres?.data?.length >= 10 && hasMoreCancelled && (
                    <div className="text-center mt-3">
                      <Button
                        variant="outline-primary"
                        onClick={handleLoadMoreCancelled}
                        disabled={loadingCancelled}
                      >
                        {loadingCancelled ? "Loading..." : "Load More"}
                      </Button>
                    </div>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      ) : (
        <OpportunityListing />
      )}
    </>
  );
};

export default TableListing;
